import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { URLS } from '@shared-config/urls';
import { EntitlmentResponse } from '@shared-interfaces/shared-entitlements';
import { Settings } from '@shared-interfaces/shared-settings';
import { Observable } from 'rxjs';

export type EntitlementStatus = 'pending' | 'loading' | 'success' | 'error';

interface EntitlementState {
  status: EntitlementStatus;
}

@Injectable({
  providedIn: 'root',
})
export class EntitlementService {
  private httpClient = inject(HttpClient);

  // don't store data in the api services - only in component or global states
  getEntitlements(subId: string): Observable<EntitlmentResponse[]> {
    return this.httpClient.get<Array<EntitlmentResponse>>(
      `${URLS.ENTITLEMENT_OVERVIEW}`,
      {
        headers: { 'Subscription-Id': subId },
        params: { product_id: environment.product_id },
      },
    );
  }

  updateEntitlements(settings: Settings): Observable<any> {
    const subId = settings.subscriptionId;
    let payload = structuredClone(settings);
    delete payload.subscriptionId;

    return this.httpClient.post<any>(`${URLS.ENTITLEMENT_UPDATE}`, payload, {
      headers: { 'subscription-id': subId! },
    });
  }
}
